import { Box } from "@mui/material";
import { styled } from "styled-components";

export const StyledDragHandle = styled(Box)<{ $selected?: boolean; $size: number; $color: string }>(
  ({ $selected, $size, $color }) => ({
    marginRight: 8,
    fontSize: 12,
    width: 24,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "none",
    position: "relative",
    color: "inherit",

    ".drag-icon": {
      opacity: 0,
      position: "absolute",
      transition: "opacity 0.2s",
    },

    ".flag-icon": {
      opacity: 1,
      transition: "opacity 0.2s",
      fontSize: $size,
    },

    "&:hover .drag-icon": {
      opacity: 1,
    },

    "&:hover .flag-icon": {
      opacity: 0,
    },

    ...($selected && {
      "& svg path": {
        fill: $color,
      },
    }),
  }),
);
